// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"233":"a89e1885","496":"eb69e33c","767":"e823892d"}[chunkId] + ".chunk.css";
};